import React, { useMemo } from 'react';
import { useNavigation } from '@react-navigation/native';

import { GET_STOCKTAKES } from '../../../common/graphql/stocktake';
import { ActionDock, Screen } from '../../design/components';

import StocktakeList from './StocktakeList';

const StocktakeListView = () => {
	const navigation = useNavigation();

	const handleOpenCreator = useMemo(() => () => {
		navigation.navigate('StocktakeCreatorView');
	}, [navigation]);

	const handleOpenDetail = useMemo(() => {
		return (stocktake) => {
			if (stocktake?.id) {
				navigation.navigate('StocktakeDetailView', { id: stocktake.id });
			}
		};
	}, [navigation]);

	return (
		<Screen
			backLabel="Warehouse"
			heading="Stocktakes"
			subheading="Count stock with batches and submit changes"
			scroll={false}
			dock={(
				<ActionDock
					action={{
						label: 'New stocktake',
						icon: 'plus',
						onPress: handleOpenCreator,
					}}
				/>
			)}
		>
			<StocktakeList
				query={GET_STOCKTAKES}
				initialSortBy="created"
				initialSortDirection={-1}
				initialPerPage={20}
				initialFilter={{}}
				listId="mobile_stocktake_list"
				customProps={{
					onPressItem: handleOpenDetail,
				}}
			/>
		</Screen>
	);
};

export default StocktakeListView;
